import React from "react";
import styles from "./RegularDialog.module.scss";
import Clear from "@mui/icons-material/Clear";
import { styled } from "@mui/material/styles";
import { Dialog, Grid } from "@mui/material";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    width: 500,
    maxWidth: 500,
    padding: 12,
  },
});

const StyledClear = styled(Clear)({
  width: 27,
  height: 27,
  fill: "#102b4e",
  align: "right",
});

const RegularDialog = (props) => {
  return (
    <StyledDialog open={props.open} className={styles.dialog}>
      <Grid
        container
        className={styles.dialogContainer}
        justifyContent="center"
      >
        <Grid item md={12} className={styles.dialogClose}>
          <div>
            <button onClick={props.close}>
              <StyledClear />
            </button>
          </div>
        </Grid>

        <Grid item md={9}>
          <div className={styles.dialogTitle}>
            {props.icon && <span className={styles.dialogWarning} />}
            <div>{props.title}</div>
          </div>
        </Grid>

        <Grid item md={9}>
          <div className={styles.dialogDescription}>{props.body}</div>
        </Grid>
      </Grid>
    </StyledDialog>
  );
};

export default RegularDialog;
